import { configureStore } from "@reduxjs/toolkit";
import MembersSlice from "../slice/MembersSlice";

export default configureStore({
    reducer: {    
      membersReducer: MembersSlice
    }

  });